/*  eslint-disable */
import { batch } from 'react-redux';

import { API_EXPLORE_URL, HIDDEN_BOOK_IDS } from '../constants';
import { callApi } from '../utils';
import { setItems } from './threads';

const collectionContainsHiddenBook = collection =>
  collection.books?.results?.some(book =>
    HIDDEN_BOOK_IDS.includes(book.id)
  );
import {
  exploreRecentColsThreadId,
  exploreFeaturedColsThreadId,
  exploreRecsThreadId,
  exploreReviewsThreadId,
} from '../selectors/explore';

export function fetchExplore({ dispatch, token }) {
  return callApi(API_EXPLORE_URL, { token }).then(data => {
    const {
      recommended,
      reviews,
      recentCollections,
      featuredCollections,
    } = data;
    const filteredRecent = recentCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    const filteredFeatured = featuredCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    batch(() => {
      const filteredRecs = recommended?.results?.filter(
        book => !HIDDEN_BOOK_IDS.includes(book.id)
      );
      dispatch(setItems(exploreRecsThreadId, filteredRecs));
      dispatch(setItems(exploreFeaturedColsThreadId, filteredFeatured));
      const filteredReviews = reviews?.results?.filter(
        item => !HIDDEN_BOOK_IDS.includes(item.book?.id)
      );
      dispatch(setItems(exploreReviewsThreadId, filteredReviews));
      dispatch(setItems(exploreRecentColsThreadId, filteredRecent));
    });
  });
}
